import { get, isEmpty } from 'lodash-es';

const NOT_AVAILABLE = 'Not Available';

/**
 * Checks whether dealer has name, city and state.
 * @param {object} inventory
 * @returns {boolean}
 */
export function hasDealerAddressInfo(inventory) {
  if (isEmpty(inventory.dealerInfo)) return false;

  const name = get(inventory, 'dealerInfo.name', '');
  const city = get(inventory, 'dealerInfo.address.city', '');
  const stateName = get(inventory, 'dealerInfo.address.stateName', '');
  const hasName = !!name && name !== NOT_AVAILABLE;
  const hasCity = !!city && city !== NOT_AVAILABLE;
  const hasState = !!stateName && stateName !== NOT_AVAILABLE;

  return hasName && hasCity && hasState;
}
